import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Typography, } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Image } from 'components/atoms';
// import Biomark from 'components/Popups/Fluidigm/Biomark';
// import Cone from 'components/Popups/Fluidigm/Cone'
// import Helios from 'components/Popups/Fluidigm/Helios'
import Hyperion from 'components/Popups/Fluidigm/Hyperion'
// import Juno from 'components/Popups/Fluidigm/Juno';
// import Lcm from 'components/Popups/Fluidigm/Lcm';
// import Polaris from 'components/Popups/Fluidigm/Polaris'
import Cytpop from 'components/Popups/Fluidigm/Cytpop'




const useStyles = makeStyles(theme => ({
  cardBase: {
    '&:hover': {
      background: theme.palette.primary.main,
      '& .card-icon, & .card-title': {
        color: 'white',
      },
    },
  },
  icon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      fontSize: 80,
    },
  },
  title: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
}));

const Fluidigmall = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
             <CardBase >

<Image src="https://onwhicar.sirv.com/premas/main/fluidigm/standard%20biotools%20logo-smmaal%5B2433%5D.png" />

</CardBase>

<br/>


      <SectionHeader
        title="Featured products"
  
        data-aos="fade-up"
      />

      {/* <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Fluidigm/juno673400_s68B-WBzc.png" />


            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              JUNO
              <br />
              <br />
              <Juno />
            </Typography>
          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Fluidigm/c1673400_tuGCybpsH.png" />
            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              c1
              <br />
              <br />
              <Cone />
             
            </Typography>
          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Fluidigm/biomark673400_6420rhydp.png" />
            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              Biomark HD
              <br />
              <br />
              <Biomark />
            </Typography>
          </CardBase>
        </Grid>
      </Grid> */}
      <Grid container spacing={isMd ? 4 : 2}>
        {/* <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Fluidigm/Helios673400_7cwofHphv.png" />


            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              Helios
              <br/>
              <br/>
              <Helios />
            </Typography>
          </CardBase>
        </Grid> */}
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/fluidigm/helios.png" />
            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              Hyperion
  <br/>
  <br/>
              <Hyperion />
            </Typography>
          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://onwhicar.sirv.com/premas/main/fluidigm/tumbcytofxt.png" />
            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              CyTOF XT
      <br/>
      <br/>
              <Cytpop />
            </Typography>
          </CardBase>
        </Grid>
        <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          {/* <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Fluidigm/lcm673400_yQQMp_2Nz.png" />


            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              LCM
              <br/>
              <br/>
              <Lcm />
            </Typography>
          </CardBase> */}
        </Grid>
        

      </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          {/* <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/polaris_gbmhNjIWnO.png" />
            </div>
            <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              className={clsx(classes.title, 'card-title')}
            >
              Polaris

              <Polaris />
            </Typography>
          </CardBase> */}
        </Grid>
      </Grid>
      
    </div>
  );
};

Fluidigmall.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Fluidigmall;
